<template>
  <v-card elevation="4" class="dashboard-card rounded-xl pa-4 fill-height interest-card">
    <div class="interest-header">
      <v-avatar color="#dff5e8" size="70" class="interest-avatar">
        <v-icon color="#009b6b" size="38">mdi-sack</v-icon>
      </v-avatar>
      <div>
        <div class="interest-title">Total intereses de tus inversiones</div>
        <div class="interest-subtitle">Acumulado hasta hoy</div>
        <div class="interest-amount">{{ formatMonto(safeIntereses.total) }}</div>
      </div>
    </div>
    <v-divider class="my-4"></v-divider>
    <div class="interest-caption mb-4"></div>
    <div class="interest-breakdown">
      <div class="interest-donut" :style="{ background: interesesDonutGradient }">
        <span></span>
      </div>
      <div class="interest-list">
        <div v-for="item in safeIntereses.detalle" :key="item.label" class="interest-list-item">
          <span class="distribution-dot" :style="{ backgroundColor: item.color }"></span>
          <strong>{{ item.label }} ({{ item.porcentaje }}%)</strong>
          <span>{{ formatMonto(item.monto) }}</span>
        </div>
      </div>
    </div>
    <div class="interest-thanks mt-5">
      <v-avatar color="#e8f8ee" size="46" class="mr-3">
        <v-icon color="#009b6b">mdi-heart-outline</v-icon>
      </v-avatar>
      <div>
        <strong>Gracias por confiar en tu cooperativa</strong>
        <span>Juntos seguimos construyendo tu futuro.</span>
      </div>
    </div>
  </v-card>
</template>

<script>
import conv from "@/services/conversores";

export default {
  name: "InterestSummaryCard",
  props: {
    intereses: {
      type: Object,
      default: () => ({ total: 0, detalle: [] })
    }
  },
  computed: {
    safeIntereses() {
      return this.intereses || { total: 0, detalle: [] };
    },
    interesesDonutGradient() {
      if (!this.safeIntereses.total) return "conic-gradient(#e9eef0 0% 100%)";

      let cursor = 0;
      const segments = this.safeIntereses.detalle.map((item) => {
        const start = cursor;
        cursor += Number(item.porcentaje) || 0;
        return `${item.color} ${start}% ${cursor}%`;
      });

      return `conic-gradient(${segments.join(", ")})`;
    }
  },
  methods: {
    formatMonto(value) {
      return conv.formatMonto(value || 0, true);
    }
  }
};
</script>

<style scoped>
.dashboard-card {
  width: 100%;
  background: #ffffff !important;
  border: 1px solid rgba(31, 45, 53, 0.08);
  box-shadow: 0 10px 28px rgba(20, 52, 57, 0.1) !important;
}

.interest-card {
  background: linear-gradient(135deg, #ffffff 0%, #f7fbf8 100%) !important;
  border-color: rgba(0, 155, 107, 0.12);
  display: flex;
  flex-direction: column;
  height: 100%;
}

.interest-header {
  align-items: flex-start;
  display: flex;
  gap: 14px;
}

.interest-avatar {
  flex: 0 0 auto;
}

.interest-title {
  color: #1c2c3d;
  font-size: 0.88rem;
  font-weight: 800;
  line-height: 1.2;
}

.interest-subtitle,
.interest-caption {
  color: #455a72;
  font-size: 0.8rem;
}

.interest-amount {
  color: #008b60;
  font-size: 1.55rem;
  font-weight: 800;
  line-height: 1.2;
  margin-top: 6px;
}

.interest-breakdown {
  align-items: center;
  display: grid;
  gap: 14px;
  grid-template-columns: 92px minmax(0, 1fr);
}

.interest-donut {
  align-items: center;
  border-radius: 50%;
  display: flex;
  height: 92px;
  justify-content: center;
  width: 92px;
}

.interest-donut span {
  background: #ffffff;
  border-radius: 50%;
  height: 44px;
  width: 44px;
}

.interest-list {
  display: flex;
  flex-direction: column;
  gap: 13px;
}

.interest-list-item {
  align-items: center;
  color: #1c2c3d;
  display: grid;
  gap: 8px;
  grid-template-columns: 10px minmax(64px, 1fr) 74px;
}

.interest-list-item strong,
.interest-list-item span {
  font-size: 0.78rem;
}

.interest-list-item strong {
  font-weight: 800;
}

.interest-list-item span:last-child {
  font-weight: 700;
  text-align: right;
}

.distribution-dot {
  border-radius: 50%;
  height: 10px;
  width: 10px;
}

.interest-thanks {
  align-items: center;
  background: rgba(37, 108, 116, 0.07);
  border-radius: 10px;
  display: flex;
  margin-top: auto !important;
  padding: 10px 12px;
}

.interest-thanks strong {
  color: var(--v-primary-base);
  display: block;
  font-size: 0.82rem;
}

.interest-thanks span {
  color: #455a72;
  display: block;
  font-size: 0.8rem;
  line-height: 1.25;
}

@media (max-width: 959px) {
  .interest-breakdown {
    grid-template-columns: 88px minmax(0, 1fr);
  }
}

@media (max-width: 599px) {
  .interest-header {
    align-items: center;
  }

  .interest-avatar {
    height: 58px !important;
    min-width: 58px !important;
    width: 58px !important;
  }

  .interest-avatar .v-icon {
    font-size: 32px !important;
  }

  .interest-amount {
    font-size: 1.3rem;
    overflow-wrap: anywhere;
  }

  .interest-breakdown {
    grid-template-columns: 88px minmax(0, 1fr);
    justify-items: stretch;
  }

  .interest-list {
    width: 100%;
  }

  .interest-list-item {
    grid-template-columns: 10px minmax(0, 1fr) auto;
  }

  .interest-list-item span:last-child {
    grid-column: auto;
    text-align: right;
  }
}
</style>
